export default "__VITE_ASSET__D4adyT_O__"